export default [
  

  {
    path: '/reports',
    name: 'reports',
    component: () => import('@/views/modules/reports/reports'),
    meta: {
      requiresAuth: true,
      title:'Reports',
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Reports' }
      ]
    },
   
  }
]